import { DateFilterAfter } from './date-filter-after';
import { DateFilterBefore } from './date-filter-before';
import { DateFilterBetween } from './date-filter-between';
import { DateFilterWithin } from './date-filter-within';
import { DateFilterComponent, FilterOption } from '../date-filter.types';

type AvaliableFilter = {
  value: FilterOption;
  component: React.FC<DateFilterComponent>;
};

export const AVALIABLE_FILTERS: AvaliableFilter[] = [
  {
    value: 'after',
    component: DateFilterAfter,
  },
  {
    value: 'before',
    component: DateFilterBefore,
  },
  {
    value: 'between',
    component: DateFilterBetween,
  },
  {
    value: 'within last',
    component: DateFilterWithin,
  },
];
